import React from 'react'
import { Container } from '@material-ui/core'
import { getDisplayName } from '../utils/react/getDisplayName'
import { Header } from '../header/Header'
import { Content } from './Content'

export function withPage(WrappedComponent) {
  function WithPage(props) {
    return (
      <React.Fragment>
        <Header {...props} />
        <Container>
          <h2>{props.title}</h2>
          <Content>
            <WrappedComponent {...props} />
          </Content>
        </Container>
      </React.Fragment>
    )
  }

  WithPage.displayName = `Page(${getDisplayName(WrappedComponent)})`

  return WithPage
}
